import {Grid} from '@primer/react-brand/esm'
import type {IconAssetLinkItem, RiverBreakout} from '../../types'
import {FlexSuiteRiverBreakout} from '../FlexSuiteRiverBreakout'
import {FlexSuiteRiverBreakoutTabs} from '../FlexSuiteRiverBreakoutTabs'

type FlexSuiteSectionBreakoutProps = {
  breakoutVariant?: 'Breakout' | 'Carousel'
  featureRiverBreakout?: RiverBreakout
  featureBreakoutTabs?: IconAssetLinkItem[]
}

export function FlexSuiteSectionBreakout({
  breakoutVariant,
  featureRiverBreakout,
  featureBreakoutTabs,
}: FlexSuiteSectionBreakoutProps) {
  let content = null

  if (breakoutVariant === 'Breakout' && featureRiverBreakout) {
    content = <FlexSuiteRiverBreakout {...featureRiverBreakout.fields} />
  } else if (breakoutVariant === 'Carousel' && featureBreakoutTabs?.length) {
    content = <FlexSuiteRiverBreakoutTabs items={featureBreakoutTabs} />
  }

  if (!content) return null

  return (
    <Grid enableGutters={false}>
      <Grid.Column>{content}</Grid.Column>
    </Grid>
  )
}
